import React from 'react'

import AddReferralModal from '@/components/modals/AddReferralModal/AddReferralModal'
import ImportHistoricalReferralsModal from '@/components/modals/ImportHistoricalReferralsModal/ImportHistoricalReferralsModal'
import LogReferralModal from '@/components/modals/LogReferralModal/LogReferralModal'
import NylasCalendarConnectionFailedModal from '@/components/modals/NylasCalendarConnectionFailedModal'
import { useCurrentCompany } from '@/hooks/useCurrentCompany'
import InviteUsersModal from '@/pages/manageUsers/components/company/InviteUsersModal'

// Add any modals here that should be globally available, regardless of the user
// scope (company user, unauthenticated) or the current page
const GlobalModals: React.FC = () => {
  const currentCompany = useCurrentCompany()

  return (
    <>
      {currentCompany && (
        <>
          <NylasCalendarConnectionFailedModal />
          <AddReferralModal />
          <ImportHistoricalReferralsModal />
          <LogReferralModal />
          <InviteUsersModal />
        </>
      )}
    </>
  )
}

export default GlobalModals
